<mdk-alert-message [alert]="currentAlert$ | async" (closeAlert)="onClickClose()"></mdk-alert-message>